import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { noop } from '../../utils/functions.js';
import { isIE } from '../../utils/platforms.js';
import { StyledDatalist, DatalistItem } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var LIST_ROLE = isIE() ? 'list' : 'listbox';
var LIST_ITEM_ROLE = isIE() ? 'listitem' : 'option';
var Datalist = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      datalist = _ref.datalist,
      selected = _ref.selected,
      handleItemClick = _ref.handleItemClick;
  var theme = useTheme();

  if (datalist.length > 0) {
    return /*#__PURE__*/React.createElement(StyledDatalist, {
      id: "".concat(id, "-list"),
      role: LIST_ROLE,
      ref: ref,
      theme: theme
    }, datalist.map(function (elem, i) {
      return /*#__PURE__*/React.createElement(DatalistItem, {
        key: "".concat(id, "-list-").concat(elem),
        id: elem,
        value: elem,
        role: LIST_ITEM_ROLE,
        isSelected: selected === i,
        "aria-selected": selected === i,
        onClick: function onClick(e) {
          return handleItemClick(e, i);
        },
        theme: theme
      }, elem);
    }));
  }

  return null;
});
process.env.NODE_ENV !== "production" ? Datalist.propTypes = {
  /** DOM element ID of text input */
  id: PropTypes.string.isRequired,

  /** Datalist content array */
  datalist: PropTypes.arrayOf(PropTypes.string),

  /** onClick handler function for the datalist element  */
  handleItemClick: PropTypes.func,

  /** HTML 5 selected attribute */
  selected: PropTypes.number
} : void 0;
Datalist.defaultProps = {
  datalist: [],
  handleItemClick: noop,
  selected: 0
};
process.env.NODE_ENV !== "production" ? Datalist.displayName = 'Datalist' : void 0;
var Datalist$1 = Datalist;

export { Datalist$1 as default };
